<template>
    <div class="tooltip">
        <button v-if="icon == true" class="tooltip-icon" @click.prevent="toggleToolTip()" aria-label="Toggle tooltip" :aria-expanded="toolTipVisible"></button>

        <div class="tooltip-content">
            <div class="tooltip-text" v-if="toolTipVisible">
                <div v-html="html"></div>
                <button class="tooltip-close-icon" v-if="toolTipVisible" @click.prevent="toggleToolTip()" v-html="''"></button>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, watch } from 'vue';

    const props = defineProps({
        html: { type: String, default: '' },
        icon: { type: Boolean, default: true },
        resetTooltip: { type: Boolean, default: false } // New prop to reset tooltip
    });

    const toolTipVisible = ref(false);

    watch(() => props.resetTooltip, (newVal) => {
        if (newVal) {
            toolTipVisible.value = false;
        }
    });

    function toggleToolTip() {
        toolTipVisible.value = !toolTipVisible.value;
    }
</script>


<style lang="scss">

.tooltip {
    margin: auto 0;
    position: relative;
}

.tooltip-content {
    position: relative;
}

.tooltip-text {
    background-color: #F1F9FF;
    background-repeat: no-repeat;
    position: absolute;
    width: 280px;
    height: auto;
    display: flex;
    flex-direction: column;
    padding: 30px 20px;
    z-index: 10;
    top: -20px;
    right: 0;
    border-radius: 5px;
    border: 1px solid #B7E3FF;
    
    @media (min-width: 450px) {
        width: 330px;
    }

    @media (min-width: 720px) {
        left: 20px;
        width: 330px;
    }

    @media (min-width: 1280px) {
        left: 24px;
    }

    h3 {
        color: #000;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 18px;
    }

    p {
        color: #666;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        margin-bottom: 24px;

        &:last-child {
            margin-bottom: 0;
        }
    }
}

.tooltip-text:before {
    display: none;
    top: 15px;
    content: "";
    background-image: url("/build/images/icon-popup.svg");
    background-repeat: no-repeat;
    background-size: 10px 30px;
    left: -10px;
    height: 30px;
    width: 11px;
    position: absolute;

    @media (min-width: 720px) {
        display: block;
    }
}

.tooltip-icon {
	color: inherit;
	border: none;
	padding: 0;
	font: inherit;
	cursor: pointer;
	outline: inherit;
    width: 20px;
    height: 20px;
    background-image: url('/build/images/icon-question-mark.svg');
    background-size: 20px;
    background-color: transparent;
}

.tooltip-close-icon {
	background: none;
	color: inherit;
	border: none;
	padding: 0;
	font: inherit;
	cursor: pointer;
	outline: inherit;
    width: 30px;
    height: 30px;
    background-image: url('/build/images/icon-tooltip-close.svg');
    background-size: 20px;
    background-repeat: no-repeat;
    background-size: 30px;
    position: absolute;
    right: 8px;
    top: 8px;
}

</style>